import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ExclamationPrimaryIcon from '../../asset/img/common/excalmation_primary_icon.svg';

import Typography from '../../components/common/Typography';
import CheckBox from '../../components/common/CheckBox';
import Button from '../../components/common/Button';
import {
  getAlertMessageFunction,
  getDeleteDialogConfig,
  magamCertifyCheck,
} from '../../common/Util';

const GetDataSection = ({ handleOpenClick }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('eDocuments');
  const { t: tCommon } = useTranslation('common');
  const { isMagam, isCertify } = useSelector(state => state.common);
  const { eDocumentStatus } = useSelector(state => state.eDocuments);
  const [selected, setSelected] = useState(0);
  // 국세청연동 사용유무
  const [isUseNts, setIsUseNts] = useState(true);

  useEffect(() => {
    //htmPdfUploadFlag "0": 업로드 안함, "1": 홈택스 API 연동, "2": PDF 직접 업로드
    //htmHomeTaxScrapeFlag => "1":사용, "2":미사용
    const { htmHomeTaxScrapeFlag, htmPdfUploadFlag } = eDocumentStatus;
    if (htmHomeTaxScrapeFlag) setIsUseNts(htmHomeTaxScrapeFlag == '1');
    if (htmPdfUploadFlag) setSelected(htmPdfUploadFlag);
  }, [eDocumentStatus]);

  const deletePDFAll = () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    dispatch(getDeleteDialogConfig(tCommon, 'eDocuments', {}));
  };

  const handleClick = flag => {
    const alertMessage = getAlertMessageFunction();
    if (flag == 'upload') {
      if (selected == '1') {
        alertMessage(t('alertMessage01'));
        return;
      }
    } else {
      if (selected == '2') {
        alertMessage(t('alertMessage01'));
        return;
      }
    }

    handleOpenClick(flag);
  };

  return (
    <>
      <div className="displayFlexColumn" style={{ gap: '4px' }}>
        <div
          className={`infoOutlineBox ${selected == '1' ? 'selected' : ''} ${
            !isUseNts ? 'disabled' : ''
          }`}
          onClick={() => isUseNts && handleClick()}>
          <div className="displayFlex" style={{ gap: '4px' }}>
            {/* 국세청에 연동할게요 */}
            <Typography variant="subtitleBold">{t('getDataSection.title1')}</Typography>
            <CheckBox className="circle" variant="circle" checked={true} />
          </div>
          <Typography variant="body2Medium" color="GrayScale-700">
            {t('getDataSection.description1')}
          </Typography>
          {/* 해당기능은 1월 16일 이후 오픈예정입니다. 내부 사정에 따라 오픈일자는 변경될 수 있습니다. */}
          {/* <Typography
            variant="captionMedium"
            color="GrayScale-600"
            style={{ whiteSpace: 'pre-wrap' }}>
            {t('getDataSection.isUseNts2')}
          </Typography> */}
        </div>
        {/* 국세청연동 사용유무 */}
        {!isUseNts && (
          <div className="displayFlex" style={{ gap: '4px' }}>
            <img src={ExclamationPrimaryIcon} alt="exclamation" />
            <Typography variant="captionMedium" color="Primary-500">
              {eDocumentStatus?.htmHomeTaxScrapeMsg || t('getDataSection.isUseNts')}
            </Typography>
          </div>
        )}
        <div
          className="displayFlex"
          style={{ gap: '4px', marginTop: '4px', alignItems: 'flex-start' }}>
          <img src={ExclamationPrimaryIcon} alt="exclamation" />
          <Typography variant="captionMedium" color="Primary-500">
            홈택스 이용자 집중으로 인해 자료 연동이 원활하지 않을 수 있습니다.
          </Typography>
        </div>
      </div>
      <div
        className={`infoOutlineBox ${selected == '2' ? 'selected' : ''}`}
        onClick={() => handleClick('upload')}>
        <div className="displayFlex" style={{ gap: '4px' }}>
          {/* 파일을 직접 올릴게요 */}
          <Typography variant="subtitleBold">{t('getDataSection.title2')}</Typography>
          <CheckBox className="circle" variant="circle" checked={true} />
        </div>
        <Typography variant="body2Medium" color="GrayScale-700">
          {t('getDataSection.description2')}
        </Typography>
      </div>
      {selected != '' && (
        <div className="displayFlex" style={{ justifyContent: 'space-between' }}>
          <Typography variant="body2Medium">{t('getDataSection.resetDescription')}</Typography>
          {/* 초기화버튼 */}
          <Button
            color="secondary"
            size="xSmall"
            value={t('getDataSection.reset')}
            onClick={() => deletePDFAll()}
          />
        </div>
      )}
    </>
  );
};

export default GetDataSection;
